import { generateSelectors } from '../helpers';
import type { StringIndexedObject } from '../../types';
import type { GeneratedState } from '../types';
export * as app from './app';
import type {
  Audit,
  AuthUser,
  Company,
  Credit,
  Document,
  Enquiry,
  Enrolment,
  Enterprise,
  Event,
  InfoAuth,
  InfoCompany,
  InfoEnquiry,
  InfoEntity,
  InfoGhost,
  InfoIP,
  InfoIntroductionStats,
  InfoLead,
  InfoOnboarding,
  InfoQuery,
  InfoRelation,
  InfoSearch,
  InfoStats,
  InfoTag,
  InfoWorkType,
  Introduction,
  Job,
  Lead,
  Monitor,
  Onboarding,
  Partner,
  Payment,
  Rate,
  Subscription,
  Tag,
  TradeSummary,
  Training,
  Transaction,
  RedirectURLs,
  Referral,
  ExportCSV,
  ExportJSON,
  InfoSession,
  Cache,
  Campaign,
  Customer,
  OwnerReport,
  EnterpriseUserRole,
  Error,
  InfoPartnerBranding,
  InfoLegacyRedirect,
  InfoCheckoutRedirect,
  InfoValidationEmail,
  JobCreditState,
  Tally,
  JobCompanyInfo,
  LeadJobSummary,
} from '../../generated/components/schemas';
import {
  auditAdapter,
  authUserAdapter,
  companyAdapter,
  creditAdapter,
  documentAdapter,
  enquiryAdapter,
  enrolmentAdapter,
  enterpriseAdapter,
  eventAdapter,
  infoAuthAdapter,
  infoCompanyAdapter,
  infoEnquiryAdapter,
  infoEntityAdapter,
  infoGhostAdapter,
  infoIPAdapter,
  infoIntroductionStatsAdapter,
  infoLeadAdapter,
  infoOnboardingAdapter,
  infoQueryAdapter,
  infoRelationAdapter,
  infoSearchAdapter,
  infoStatsAdapter,
  infoTagAdapter,
  infoWorkTypeAdapter,
  introductionAdapter,
  jobAdapter,
  leadAdapter,
  monitorAdapter,
  onboardingAdapter,
  partnerAdapter,
  paymentAdapter,
  rateAdapter,
  subscriptionAdapter,
  tagAdapter,
  tradeSummaryAdapter,
  trainingAdapter,
  transactionAdapter,
  postCompanyBillingAdapter,
  getCompanyDirectorVerificationAdapter,
  postCompanyDirectorVerificationAdapter,
  getCompanyReferralsAdapter,
  postCompanyReferralsAdapter,
  exportFcaApprovedAdapter,
  importFcaApprovedAdapter,
  exportEnterpriseDailyReportAdapter,
  infoSessionAdapter,
  infoGetCacheAdapter,
  infoPutCacheAdapter,
  infoDeleteCacheAdapter,
  infoCampaignAdapter,
  infoCustomerAdapter,
  infoDirectorAdapter,
  infoEnterpriseRoleAdapter,
  infoEnterpriseAdapter,
  infoHealthAdapter,
  infoPartnerBrandingAdapter,
  infoLegacyRedirectAdapter,
  infoCheckoutRedirectAdapter,
  infoValidateEmailAdapter,
  checkJobAdapter,
  payoutsJobAdapter,
  jobCheckoutLinkAdapter,
  jobCompanyInfoAdapter,
  exportJobPayoutsAdapter,
  tradeQuoteApprovalLeadAdapter,
  matchTradesLeadAdapter,
  connectTradesLeadAdapter,
  acceptedJobSummaryLeadAdapter,
} from '../adapters';

export const getSelectors = () => {
  const audit = generateSelectors<
    Audit,
    StringIndexedObject<GeneratedState<Audit>>
  >('audit', auditAdapter);
  const authUser = generateSelectors<
    AuthUser,
    StringIndexedObject<GeneratedState<AuthUser>>
  >('authUser', authUserAdapter);
  const company = generateSelectors<
    Company,
    StringIndexedObject<GeneratedState<Company>>
  >('company', companyAdapter);
  const credit = generateSelectors<
    Credit,
    StringIndexedObject<GeneratedState<Credit>>
  >('credit', creditAdapter);
  const document = generateSelectors<
    Document,
    StringIndexedObject<GeneratedState<Document>>
  >('document', documentAdapter);
  const enquiry = generateSelectors<
    Enquiry,
    StringIndexedObject<GeneratedState<Enquiry>>
  >('enquiry', enquiryAdapter);
  const enrolment = generateSelectors<
    Enrolment,
    StringIndexedObject<GeneratedState<Enrolment>>
  >('enrolment', enrolmentAdapter);
  const enterprise = generateSelectors<
    Enterprise,
    StringIndexedObject<GeneratedState<Enterprise>>
  >('enterprise', enterpriseAdapter);
  const event = generateSelectors<
    Event,
    StringIndexedObject<GeneratedState<Event>>
  >('event', eventAdapter);
  const infoAuth = generateSelectors<
    InfoAuth,
    StringIndexedObject<GeneratedState<InfoAuth>>
  >('infoAuth', infoAuthAdapter);
  const infoCompany = generateSelectors<
    InfoCompany,
    StringIndexedObject<GeneratedState<InfoCompany>>
  >('infoCompany', infoCompanyAdapter);
  const infoEnquiry = generateSelectors<
    InfoEnquiry,
    StringIndexedObject<GeneratedState<InfoEnquiry>>
  >('infoEnquiry', infoEnquiryAdapter);
  const infoEntity = generateSelectors<
    InfoEntity,
    StringIndexedObject<GeneratedState<InfoEntity>>
  >('infoEntity', infoEntityAdapter);
  const infoGhost = generateSelectors<
    InfoGhost,
    StringIndexedObject<GeneratedState<InfoGhost>>
  >('infoGhost', infoGhostAdapter);
  const infoIP = generateSelectors<
    InfoIP,
    StringIndexedObject<GeneratedState<InfoIP>>
  >('infoIP', infoIPAdapter);
  const infoIntroductionStats = generateSelectors<
    InfoIntroductionStats,
    StringIndexedObject<GeneratedState<InfoIntroductionStats>>
  >('infoIntroductionStats', infoIntroductionStatsAdapter);
  const infoLead = generateSelectors<
    InfoLead,
    StringIndexedObject<GeneratedState<InfoLead>>
  >('infoLead', infoLeadAdapter);
  const infoOnboarding = generateSelectors<
    InfoOnboarding,
    StringIndexedObject<GeneratedState<InfoOnboarding>>
  >('infoOnboarding', infoOnboardingAdapter);
  const infoQuery = generateSelectors<
    InfoQuery,
    StringIndexedObject<GeneratedState<InfoQuery>>
  >('infoQuery', infoQueryAdapter);
  const infoRelation = generateSelectors<
    InfoRelation,
    StringIndexedObject<GeneratedState<InfoRelation>>
  >('infoRelation', infoRelationAdapter);
  const infoSearch = generateSelectors<
    InfoSearch,
    StringIndexedObject<GeneratedState<InfoSearch>>
  >('infoSearch', infoSearchAdapter);
  const infoStats = generateSelectors<
    InfoStats,
    StringIndexedObject<GeneratedState<InfoStats>>
  >('infoStats', infoStatsAdapter);
  const infoTag = generateSelectors<
    InfoTag,
    StringIndexedObject<GeneratedState<InfoTag>>
  >('infoTag', infoTagAdapter);
  const infoWorkType = generateSelectors<
    InfoWorkType,
    StringIndexedObject<GeneratedState<InfoWorkType>>
  >('infoWorkType', infoWorkTypeAdapter);
  const introduction = generateSelectors<
    Introduction,
    StringIndexedObject<GeneratedState<Introduction>>
  >('introduction', introductionAdapter);
  const job = generateSelectors<Job, StringIndexedObject<GeneratedState<Job>>>(
    'job',
    jobAdapter,
  );
  const lead = generateSelectors<
    Lead,
    StringIndexedObject<GeneratedState<Lead>>
  >('lead', leadAdapter);
  const monitor = generateSelectors<
    Monitor,
    StringIndexedObject<GeneratedState<Monitor>>
  >('monitor', monitorAdapter);
  const onboarding = generateSelectors<
    Onboarding,
    StringIndexedObject<GeneratedState<Onboarding>>
  >('onboarding', onboardingAdapter);
  const partner = generateSelectors<
    Partner,
    StringIndexedObject<GeneratedState<Partner>>
  >('partner', partnerAdapter);
  const payment = generateSelectors<
    Payment,
    StringIndexedObject<GeneratedState<Payment>>
  >('payment', paymentAdapter);
  const rate = generateSelectors<
    Rate,
    StringIndexedObject<GeneratedState<Rate>>
  >('rate', rateAdapter);
  const subscription = generateSelectors<
    Subscription,
    StringIndexedObject<GeneratedState<Subscription>>
  >('subscription', subscriptionAdapter);
  const tag = generateSelectors<Tag, StringIndexedObject<GeneratedState<Tag>>>(
    'tag',
    tagAdapter,
  );
  const tradeSummary = generateSelectors<
    TradeSummary,
    StringIndexedObject<GeneratedState<TradeSummary>>
  >('tradeSummary', tradeSummaryAdapter);
  const training = generateSelectors<
    Training,
    StringIndexedObject<GeneratedState<Training>>
  >('training', trainingAdapter);
  const transaction = generateSelectors<
    Transaction,
    StringIndexedObject<GeneratedState<Transaction>>
  >('transaction', transactionAdapter);
  const postCompanyBilling = generateSelectors<
    RedirectURLs,
    StringIndexedObject<GeneratedState<RedirectURLs>>
  >('postCompanyBilling', postCompanyBillingAdapter);
  const getCompanyDirectorVerification = generateSelectors<
    InfoCompany,
    StringIndexedObject<GeneratedState<InfoCompany>>
  >('getCompanyDirectorVerification', getCompanyDirectorVerificationAdapter);
  const postCompanyDirectorVerification = generateSelectors<
    InfoCompany,
    StringIndexedObject<GeneratedState<InfoCompany>>
  >('postCompanyDirectorVerification', postCompanyDirectorVerificationAdapter);
  const getCompanyReferrals = generateSelectors<
    Referral,
    StringIndexedObject<GeneratedState<Referral>>
  >('getCompanyReferrals', getCompanyReferralsAdapter);
  const postCompanyReferrals = generateSelectors<
    Referral,
    StringIndexedObject<GeneratedState<Referral>>
  >('postCompanyReferrals', postCompanyReferralsAdapter);
  const exportFcaApproved = generateSelectors<
    ExportCSV,
    StringIndexedObject<GeneratedState<ExportCSV>>
  >('exportFcaApproved', exportFcaApprovedAdapter);
  const importFcaApproved = generateSelectors<
    ExportCSV,
    StringIndexedObject<GeneratedState<ExportCSV>>
  >('importFcaApproved', importFcaApprovedAdapter);
  const exportEnterpriseDailyReport = generateSelectors<
    ExportJSON,
    StringIndexedObject<GeneratedState<ExportJSON>>
  >('exportEnterpriseDailyReport', exportEnterpriseDailyReportAdapter);
  const infoSession = generateSelectors<
    InfoSession,
    StringIndexedObject<GeneratedState<InfoSession>>
  >('infoSession', infoSessionAdapter);
  const infoGetCache = generateSelectors<
    Cache,
    StringIndexedObject<GeneratedState<Cache>>
  >('infoGetCache', infoGetCacheAdapter);
  const infoPutCache = generateSelectors<
    Cache,
    StringIndexedObject<GeneratedState<Cache>>
  >('infoPutCache', infoPutCacheAdapter);
  const infoDeleteCache = generateSelectors<
    Cache,
    StringIndexedObject<GeneratedState<Cache>>
  >('infoDeleteCache', infoDeleteCacheAdapter);
  const infoCampaign = generateSelectors<
    Campaign,
    StringIndexedObject<GeneratedState<Campaign>>
  >('infoCampaign', infoCampaignAdapter);
  const infoCustomer = generateSelectors<
    Customer,
    StringIndexedObject<GeneratedState<Customer>>
  >('infoCustomer', infoCustomerAdapter);
  const infoDirector = generateSelectors<
    OwnerReport,
    StringIndexedObject<GeneratedState<OwnerReport>>
  >('infoDirector', infoDirectorAdapter);
  const infoEnterpriseRole = generateSelectors<
    EnterpriseUserRole,
    StringIndexedObject<GeneratedState<EnterpriseUserRole>>
  >('infoEnterpriseRole', infoEnterpriseRoleAdapter);
  const infoEnterprise = generateSelectors<
    Enterprise,
    StringIndexedObject<GeneratedState<Enterprise>>
  >('infoEnterprise', infoEnterpriseAdapter);
  const infoHealth = generateSelectors<
    Error,
    StringIndexedObject<GeneratedState<Error>>
  >('infoHealth', infoHealthAdapter);
  const infoPartnerBranding = generateSelectors<
    InfoPartnerBranding,
    StringIndexedObject<GeneratedState<InfoPartnerBranding>>
  >('infoPartnerBranding', infoPartnerBrandingAdapter);
  const infoLegacyRedirect = generateSelectors<
    InfoLegacyRedirect,
    StringIndexedObject<GeneratedState<InfoLegacyRedirect>>
  >('infoLegacyRedirect', infoLegacyRedirectAdapter);
  const infoCheckoutRedirect = generateSelectors<
    InfoCheckoutRedirect,
    StringIndexedObject<GeneratedState<InfoCheckoutRedirect>>
  >('infoCheckoutRedirect', infoCheckoutRedirectAdapter);
  const infoValidateEmail = generateSelectors<
    InfoValidationEmail,
    StringIndexedObject<GeneratedState<InfoValidationEmail>>
  >('infoValidateEmail', infoValidateEmailAdapter);
  const checkJob = generateSelectors<
    JobCreditState,
    StringIndexedObject<GeneratedState<JobCreditState>>
  >('checkJob', checkJobAdapter);
  const payoutsJob = generateSelectors<
    Tally,
    StringIndexedObject<GeneratedState<Tally>>
  >('payoutsJob', payoutsJobAdapter);
  const jobCheckoutLink = generateSelectors<
    RedirectURLs,
    StringIndexedObject<GeneratedState<RedirectURLs>>
  >('jobCheckoutLink', jobCheckoutLinkAdapter);
  const jobCompanyInfo = generateSelectors<
    JobCompanyInfo,
    StringIndexedObject<GeneratedState<JobCompanyInfo>>
  >('jobCompanyInfo', jobCompanyInfoAdapter);
  const exportJobPayouts = generateSelectors<
    ExportCSV,
    StringIndexedObject<GeneratedState<ExportCSV>>
  >('exportJobPayouts', exportJobPayoutsAdapter);
  const tradeQuoteApprovalLead = generateSelectors<
    Job,
    StringIndexedObject<GeneratedState<Job>>
  >('tradeQuoteApprovalLead', tradeQuoteApprovalLeadAdapter);
  const matchTradesLead = generateSelectors<
    TradeSummary,
    StringIndexedObject<GeneratedState<TradeSummary>>
  >('matchTradesLead', matchTradesLeadAdapter);
  const connectTradesLead = generateSelectors<
    TradeSummary,
    StringIndexedObject<GeneratedState<TradeSummary>>
  >('connectTradesLead', connectTradesLeadAdapter);
  const acceptedJobSummaryLead = generateSelectors<
    LeadJobSummary,
    StringIndexedObject<GeneratedState<LeadJobSummary>>
  >('acceptedJobSummaryLead', acceptedJobSummaryLeadAdapter);

  return {
    audit,
    authUser,
    company,
    credit,
    document,
    enquiry,
    enrolment,
    enterprise,
    event,
    infoAuth,
    infoCompany,
    infoEnquiry,
    infoEntity,
    infoGhost,
    infoIP,
    infoIntroductionStats,
    infoLead,
    infoOnboarding,
    infoQuery,
    infoRelation,
    infoSearch,
    infoStats,
    infoTag,
    infoWorkType,
    introduction,
    job,
    lead,
    monitor,
    onboarding,
    partner,
    payment,
    rate,
    subscription,
    tag,
    tradeSummary,
    training,
    transaction,
    postCompanyBilling,
    getCompanyDirectorVerification,
    postCompanyDirectorVerification,
    getCompanyReferrals,
    postCompanyReferrals,
    exportFcaApproved,
    importFcaApproved,
    exportEnterpriseDailyReport,
    infoSession,
    infoGetCache,
    infoPutCache,
    infoDeleteCache,
    infoCampaign,
    infoCustomer,
    infoDirector,
    infoEnterpriseRole,
    infoEnterprise,
    infoHealth,
    infoPartnerBranding,
    infoLegacyRedirect,
    infoCheckoutRedirect,
    infoValidateEmail,
    checkJob,
    payoutsJob,
    jobCheckoutLink,
    jobCompanyInfo,
    exportJobPayouts,
    tradeQuoteApprovalLead,
    matchTradesLead,
    connectTradesLead,
    acceptedJobSummaryLead,
  };
};
